import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { contributeFormActiveSelector } from '../../../store/selectors/form';
import { usePdfOcrViewerContext } from '../../organisms/PdfOcrViewer/PdfOcrViewerContext';
import { useOcrMapping } from '../../../contexts/OcrMappingContext';

const getFieldFromAnswer = (answer, fieldId) => {
  if (!answer?.blocks) {
    return null;
  }

  const parts = fieldId.split('.');
  if (parts.length === 1) {
    return answer.fields?.find((f) => f.id === fieldId);
  }

  return traverseBlocks(answer.blocks, parts);
};

const traverseBlocks = (blocks, parts) => {
  // Find the block
  const block = blocks.find((b) => b.id === parts[0]);
  if (block == null) {
    return null;
  }

  // Grab the row
  const rowIndex = parts[1].match(/\d+/)[0];
  const row = block.rows[rowIndex];

  return getFieldFromAnswer(row, parts.slice(2).join('.'));
};

const PDFOCRGeolocProbe = ({ answer }) => {
  const activeField = useSelector(contributeFormActiveSelector);
  const { viewers } = usePdfOcrViewerContext();
  const { getField } = useOcrMapping();

  useEffect(() => {
    // Geoloc doesn't have an id for the viewer in case of multiple viewers,
    // always grab the first one
    const viewer = viewers[Object.keys(viewers)[0]];
    if (viewer == null) {
      return;
    }

    if (activeField == null) {
      viewer.handleGoToField(null);
      return;
    }

    // Essayer d'abord de trouver le field dans le mapping OCR
    let field = getField(activeField);

    // Fallback: si pas dans le mapping, chercher dans l'answer (pour compatibilité)
    if (!field) {
      field = getFieldFromAnswer(answer, activeField);
    }

    // Notify the PdfOcrViewer that a field is selected
    viewer.handleGoToField(field);
  }, [activeField, answer, viewers, getField]);

  return null;
};

PDFOCRGeolocProbe.propTypes = {
  answer: PropTypes.object,
};

export default PDFOCRGeolocProbe;
